export const googleLogin = async () => {
  const url = `${process.env.REACT_APP_API_URL}/api/auth/google`;
  window.location.href = url;
};

export const login = async (data: any) => {
  const url = `${process.env.REACT_APP_API_URL}/api/auth/signin`;
  const strData = JSON.stringify(data);
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: strData,
  });
  const res = await response.json();
  if (!response.ok) {
    return { success: false, message: res.message || res.error };
  }
  return res;
};

export const register = async (data: any) => {
  const url = `${process.env.REACT_APP_API_URL}/api/auth/signup`;
  const strData = JSON.stringify(data);
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: strData,
  });
  const res = await response.json();
  if (!response.ok) {
    return { success: false, message: res.message || res.error };
  }
  return res;
};

export const verify2fa = async (data: any) => {
  const url = `${process.env.REACT_APP_API_URL}/api/auth/verify-2fa`;
  const strData = JSON.stringify(data);
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: strData,
  });
  const res = await response.json();
  if (!response.ok) {
    return { success: false, message: res.message || res.error };
  }
  return res;
};